import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { TransportOptionsAdministrationContext } from '../../transport-options-administration.context';
import { TransportOption } from '../../transport-options.model';

@Component({
    selector: 'app-time-priority-list',
    templateUrl: './time-priority-list.component.html',
    styleUrls: ['./time-priority-list.component.scss'],
    standalone: false
})
export class TimePriorityListComponent implements OnInit {

  options = new Array<TransportOption>();

  private eventSource = 'app-time-priority-list';

  context: TransportOptionsAdministrationContext;
  contextSubscription: Subscription;

  @Input() set optionsContext(optionsContext: TransportOptionsAdministrationContext) {
    this.context = optionsContext;

    if (this.contextSubscription != null) {
      this.contextSubscription.unsubscribe();
    }
    if (this.context != null) {
      this.preparePriorityList();
      this.contextSubscription = this.context.contextChange$.subscribe(
        change => {
          if (change.source !== this.eventSource && change.key === 'options-changed') {
            this.preparePriorityList();
          }
        }
      );
    }
  }

  constructor(
    public translationService: TranslationService
  ) { }

  ngOnInit(): void {
  }

  drop(event: CdkDragDrop<TransportOption[]>) {
    moveItemInArray(this.options, event.previousIndex, event.currentIndex);

    for (let i = 0; i < this.options.length; i++) {
      this.options[i].timeSlotPriority = this.options.length - 1 - i;
    }
    this.context.setOptions(this.options, this.eventSource);
    this.context.dirty = true;
  }

  private preparePriorityList() {

    const sortedOptions = new Array<TransportOption>();

    this.context.options.forEach(
      o => {
        if (!o.deleted) {
          sortedOptions.push(o);
        }
      }
    );

    sortedOptions.sort((a: TransportOption, b: TransportOption) => {
      return b.id - a.id;
    });
    sortedOptions.sort((a: TransportOption, b: TransportOption) => {
      return b.timeSlotPriority - a.timeSlotPriority;
    });

    this.options = sortedOptions;
  }
}
